import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ReportsResource } from '../../ReportsStore/Types';
import ReportItems from './ReportItems';

interface Props {
  reportsResource: ReportsResource;
}

const ReportsView: React.FC<Props> = ({ reportsResource }) => {
  return (
    <>
      <div className="py-5 px-2.5 lg:px-12">
        <div className="mt-6">
          {fromEmpty(reportsResource.payload.reports)
            .map((reports) => <ReportItems reports={reports} />)
            .getOrElse(() => (
              <></>
            ))}
        </div>
      </div>
    </>
  );
};

export default observer(ReportsView);
